/**
 * The outcome list's column grid, shared by its head and its rows (CAE-1552).
 *
 * Here rather than in either file because a head and a row that disagree about
 * their columns is a table with its labels over the wrong cells, and two copies
 * of a seven-track `grid-template-columns` is exactly how that happens.
 *
 * > **The stylesheet's widths, not the ticket's.** `06-edit-reels/README.md`
 * > tabulates 24 / 56 / 1fr / 80 / 110 / 64 / auto; `.rl-outcomes-head` draws
 * > `28px 64px minmax(0,1fr) 90px 110px 80px 152px` at a 14px gap. The
 * > stylesheet wins (CAE-1537), and the prose's `auto` last track would anyway
 * > let the icon buttons size a column the head has no label for.
 *
 * **The one width that is neither: actions, at 88 rather than 152.** The
 * stylesheet sizes that track for the handoff's four buttons — info, upload,
 * delete, more. The upload one is not built: the image slot two columns left is
 * already the control that sets artwork, and `Replace asset…` in the more-menu
 * is the same action named. 88 is what the three that *are* built measure —
 * three 24px icon buttons, two 4px gaps, 8px of slack for their focus rings —
 * and every pixel above that comes out of the only column on the row with prose
 * in it.
 *
 * That column is genuinely tight. At the design's own 1240px page the six fixed
 * tracks and their gaps take 568, and the outcome name is left with the
 * remainder — which fits the handoff's mock ("Mexico vs South Africa · 90
 * Minutes") and does not fit the feed's real names ("FIFA World Cup 2026 -
 * Group A · Both To Qualify From Group"). The row clips rather than wraps; see
 * the note on the meta line in `reel-option-row.tsx`.
 */
export const REEL_OPTION_COLUMNS = '28px 64px minmax(0, 1fr) 90px 110px 80px 88px';

/**
 * Below this the list scrolls inside itself rather than shedding a column.
 *
 * **Measured against the box the table actually gets, not the column around
 * it.** The page caps at `max-width: 1240`; inside that the detail side is
 * 895px and the card's own 28px of padding leaves the table **839**. An earlier
 * 870 was reasoned from the 895 and so overflowed by 31px at *every* window
 * size — macOS draws no resting scrollbar, so the row's last cell simply was
 * not there, and with it the more-menu that is the only route to the
 * display-name override and `Replace asset…`. Found by driving the screen and
 * reading `getBoundingClientRect()` against the clip.
 *
 * 822 is that 839 with 17px to spare: the five fixed tracks and the actions one
 * (460), six 14px gaps (84) and the row's 28px of padding leave 250 for the
 * name, which seats the two meta fields at their 76px minimums plus their
 * separators. Scrolling rather than dropping a column is the trade CAE-1542
 * settled for the Contests list and CAE-1574 repeated for the Overview's
 * outcome table — it just has to begin below the width the screen really has.
 */
export const REEL_OPTION_TABLE_MIN_WIDTH = 822;
